import {EuiPage, EuiPageBody, EuiPageHeader, EuiPageSection} from "@elastic/eui";
import {Outlet} from "react-router-dom";
import React from "react";

export const ProductsPage: React.FC = () => {
    return (
        <EuiPage>
            <EuiPageBody>
                <EuiPageSection>
                    <EuiPageHeader pageTitle={"Product Management"}/>
                </EuiPageSection>
                <EuiPageSection>
                    <Outlet />
                </EuiPageSection>
            </EuiPageBody>
        </EuiPage>
    )
}